<div class="container section__phoneRegister h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article>
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"/>
        <div class="mainInfo">
          <h1>De acuerdo, ahora vamos a enrolar el teléfono</h1>
        </div>

        <div class="generalImg mt-20 mb-20">
          <app-enrollment-illustration></app-enrollment-illustration>
        </div>

        <div class="generalDescription mb-30">
          <p class="big">El teléfono quedará como <strong class="highlight">garantía de pago</strong> por el prestamo que te estamos realizando. Es por eso que vamos a enrolarlo.</p>
        </div>

        <div class="subtitle mb-15">
          <h2>Importante:</h2>
        </div>

        <div class="stepBox">
          <div class="text smallList">
            <ul>
              <li class="generalDescription">
                <p>Necesitarás buscar en el teléfono tu IMEI 1 e ingresarlo.</p>
              </li>
            </ul>
          </div>
        </div>
      </article>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Ya tengo mi IMEI" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onIntroduceIMEI()"></button>

          <div class="footer__float">
            <p-button label="¿Dónde encontrar mi IMEI?" [text]="true" [plain]="true" (onClick)="onSearchIMEI()"></p-button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>